
// import { useFormContext, Controller } from 'react-hook-form';


// export default function RHSelectField({ name, helperText, list, label, required, ...other }) {
//   const { control } = useFormContext();
//   return (
//     <Controller
//       name={name}
//       control={control}
//       render={({ field, fieldState: { error } }) => (
//         <>

//           <label htmlFor={name} className="form-label">{label} {required && <span
//             className="text-danger">*</span>}</label>
//           <select className={`form-select  ${error?.message && 'is-invalid'}`} name={name}   {...field}  {...other}>

//             <option >
//               Select option
//             </option>
//             {list?.map((ele, ind) => (
//               <option key={ind} value={ele.value}>
//                 {ele.name}
//               </option>
//             ))}

//           </select>


//           <div className="invalid-feedback">{error?.message}</div>



//         </>
//       )}
//     />
//   );
// }
import { useFormContext, Controller } from 'react-hook-form';

export default function RHSelectField({ name, helperText, list, label, required, productListFn, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <>
          <label htmlFor={name} className="form-label">
            {label} {required && <span className="text-danger">*</span>}
          </label>
          {productListFn ?
            <select
              className={`form-select  ${error?.message && 'is-invalid'}`}
              name={name}
              {...field}
              {...other}
              onChange={(e) => {
                const selectedValue = e.target.value;
                field.onChange(selectedValue); // Update the form value
                if (selectedValue && productListFn) {
                  productListFn(`categoryId=["${selectedValue}"]`);
                }
              }}
            >
              <option>Select option</option>
              {list?.map((ele, ind) => (
                <option key={ind} value={ele.value}>
                  {ele.name}
                </option>
              ))}
            </select>
            :
            <select
              className={`form-select  ${error?.message && 'is-invalid'}`}
              name={name}
              {...field}
              {...other}
            >
              <option>Select option</option>
              {list?.map((ele, ind) => (
                <option key={ind} value={ele.value}>
                  {ele.name}
                </option>
              ))}
            </select>
          }
          <div className="invalid-feedback">{error?.message}</div>
        </>
      )}
    />
  );
}